/**
 * @param fn 处理函数
 * @param wait 时间
 */
let timeout:any = null
export default function (fn: Function, wait: number = 500){
	if(timeout !== null) clearTimeout(timeout)
    timeout = setTimeout(fn, wait)
}